import React from "react";
import { WrenchIcon } from "lucide-react";
import { CtaButton } from "../CtaButton";
import { SectionHeading } from "../SectionHeading";
import { tools } from "../../data/content";
export function Tools() {
  return <section className="bg-white px-4 py-16 sm:py-24" data-id="element-262" data-mp="2hiqbjeexc336">
      <SectionHeading kicker="Additional practical tools" title="5 Resources to Support Your Planning Workflow" subtitle="Alongside the six core volumes, you’ll have five practical resources designed to complement your collection." data-id="element-263" data-mp="2dig6c3yyhgpd" />

      <ul className="mx-auto mt-10 max-w-3xl divide-y divide-navy/10 rounded-[2rem] bg-teal-soft px-5 sm:px-8" data-id="element-264" data-mp="23rbqz35dbtu0">
        {tools.map((t, i) => <li key={t.title} className="flex gap-4 py-5" data-id="element-265" data-mp="1tuz00d17ju2y" data-mpi={i}>
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-teal text-white" data-id="element-266" data-mp="1tw9zw1rj8hos">
              <WrenchIcon className="h-5 w-5" aria-hidden="true" data-id="element-267" data-mp="1puoh5zsbh96o" />
            </span>
            <div data-id="element-268" data-mp="1kvvg56u7vane">
              <p className="text-sm font-extrabold uppercase tracking-wide text-teal-dark" data-id="element-269" data-mp="159g63mwe13i6">Tool {i + 1}</p>
              <h3 className="font-display text-xl font-bold text-navy" data-id="element-270" data-mp="1a06dt6sadig1">{t.title}</h3>
              <p className="mt-1 text-base leading-relaxed text-ink-soft" data-id="element-271" data-mp="1a20yql3k5ak4">{t.text}</p>
            </div>
          </li>)}
      </ul>

      <p className="mx-auto mt-8 max-w-2xl text-center text-base text-ink-soft" data-id="element-272" data-mp="109lgdmocmjyp">
        These resources complement the six workbooks and provide additional ways to organize recurring tasks.
      </p>
      <CtaButton label="Get your complete planning toolkit" className="mt-8" data-id="element-273" data-mp="1szajq6oj6w3h" />
    </section>;
}